import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerModule,
} from "@angular/platform-browser";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule } from "@angular/common/http";
import { ReUsableModule } from "./Components/re-usable.module";
import { NgxSpinnerModule } from "ngx-spinner";
import { httpInterceptorProviders } from "./Interceptors";
import { PrimeNgModule } from "./DesignModules/prime-ng.module";
import { CookieService } from "ngx-cookie-service";
import {
  LyHammerGestureConfig,
  LY_THEME,
  LY_THEME_NAME,
  StyleRenderer,
  LyTheme2,
} from "@alyle/ui";
import { MinimaLight } from "@alyle/ui/themes/minima";
import { LoggerModule, NgxLoggerLevel } from "ngx-logger";
import { DatePipe } from "@angular/common";
import {
  NgxMatDateAdapter,
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
} from "@angular-material-components/datetime-picker";
import { MatIconModule } from "@angular/material/icon";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    HttpClientModule,
    ReUsableModule,
    PrimeNgModule,
    HammerModule,
    NgxMatDatetimePickerModule,
    LoggerModule.forRoot({ level: NgxLoggerLevel.TRACE }),
    FontAwesomeModule,
  ],
  providers: [
    httpInterceptorProviders,
    CookieService,
    DatePipe,
    NgxMatNativeDateModule,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: LyHammerGestureConfig,
    },
    NgxMatDatetimePickerModule,
    StyleRenderer,
    LyTheme2,
    {
      provide: LY_THEME_NAME,
      useValue: "minima-light",
    },
    {
      provide: LY_THEME,
      useClass: MinimaLight,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
